import { Ethnicity } from "@/Common/Models/UI/Ethnicity";
import { DropdownItem } from "./DropdownItem";

class EthnicityDropdownItem extends DropdownItem<Ethnicity> { }

export { DropdownItem, EthnicityDropdownItem };
